import { SvgIconProps } from "@mui/material";
import React, { FC } from "react";

const Star: FC<SvgIconProps & { pathClassname?: SvgIconProps['className']}> = ({ fill, pathClassname, ...rest }) => {
  return (
    <svg
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M35.3972 12.9365L24.6474 11.3742L19.8419 1.63206C19.7107 1.36533 19.4947 1.1494 19.228 1.01815C18.5591 0.687909 17.7461 0.963111 17.4117 1.63206L12.6062 11.3742L1.85643 12.9365C1.56006 12.9788 1.28909 13.1186 1.08163 13.3302C0.830828 13.588 0.692621 13.9348 0.697385 14.2945C0.702148 14.6541 0.849491 14.9971 1.10704 15.2482L8.88466 22.8311L7.04716 33.5385C7.00407 33.7876 7.03163 34.0438 7.12672 34.278C7.22181 34.5122 7.38062 34.7151 7.58515 34.8636C7.78968 35.0122 8.03173 35.1004 8.28387 35.1184C8.53601 35.1364 8.78814 35.0834 9.01167 34.9653L18.6268 29.9101L28.2419 34.9653C28.5044 35.105 28.8093 35.1516 29.1014 35.1008C29.8381 34.9738 30.3334 34.2752 30.2064 33.5385L28.3689 22.8311L36.1466 15.2482C36.3582 15.0407 36.498 14.7698 36.5403 14.4734C36.6546 13.7325 36.1381 13.0466 35.3972 12.9365V12.9365Z"
        fill={fill ?? 'currentColor'}
        className={pathClassname}
      />
    </svg>
  );
};

export default Star;
